(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-social-proof"] && !Shopify.designMode) return;
  try {
    

(() => {

  const registryKey = '__primeSocialProofPlacement';

  window[registryKey] = window[registryKey] || {};

  const visibleElement = (root, selectors) => {

    for (const selector of selectors) {

      const elements = root.querySelectorAll(selector);

      for (const element of elements) {

        if (element.getClientRects().length > 0) {
          return element;
        }

      }

    }

    return null;
  };


  const getAddButton = () => visibleElement(document, [

    'main .product__info-container form[action*="/cart/add"] button[name="add"]',

    'main .product-information form[action*="/cart/add"] button[name="add"]',

    'main .product-info form[action*="/cart/add"] button[name="add"]',

    'main form[action*="/cart/add"] button[name="add"]',

    'main .product-form__submit',

    'main [data-add-to-cart]',

    'form[action*="/cart/add"] button[name="add"]',

    '.product-form__submit'

  ]);


  const getBuyButtonsTarget = (button) => {

    if (!button) {
      return null;
    }

    return (
      button.closest('[data-buy-buttons]') ||
      button.closest('.product-form__buttons') ||
      button.closest('.buy-buttons') ||
      button.closest('product-form') ||
      button.closest('.product-form') ||
      button.closest('form[action*="/cart/add"]')
    );

  };


  const normalizeCustomTarget = (value) => {

    if (!value) {
      return '';
    }

    return value
      .trim()
      .replace(/^#/, '');

  };


  const init = (content) => {

    if (
      !content ||
      !content.matches('[data-prime-social-proof]')
    ) {
      return;
    }


    const sectionId = content.dataset.sectionId;

    if (!sectionId) {
      return;
    }


    const previous = window[registryKey][sectionId];

    if (
      previous &&
      typeof previous.destroy === 'function'
    ) {
      previous.destroy();
    }


    const wrapper = document.getElementById(
      `shopify-section-${sectionId}`
    );

    if (!wrapper) {
      return;
    }


    let observer = null;
    let timer = null;
    let destroyed = false;


    const position = () => {
      return content.dataset.position || 'normal';
    };


    const isImmediatelyBefore = (node, target) => {

      return (
        node.parentNode === target.parentNode &&
        node.nextElementSibling === target
      );

    };


    const isImmediatelyAfter = (node, target) => {

      return (
        node.parentNode === target.parentNode &&
        target.nextElementSibling === node
      );

    };


    const place = () => {

      if (destroyed) {
        return true;
      }


      const mode = position();


      if (mode === 'normal') {
        return true;
      }


      if (mode === 'custom') {

        const targetId = normalizeCustomTarget(
          content.dataset.customTarget
        );

        const placeholder = targetId
          ? document.getElementById(targetId)
          : null;


        if (!placeholder) {
          return false;
        }


        if (wrapper.parentNode !== placeholder) {
          placeholder.appendChild(wrapper);
        }


        return true;
      }


      const addButton = getAddButton();

      const buyButtons = getBuyButtonsTarget(
        addButton
      );


      if (
        !buyButtons ||
        !buyButtons.parentNode
      ) {
        return false;
      }


      if (mode === 'above_buy_buttons') {

        if (
          !isImmediatelyBefore(
            wrapper,
            buyButtons
          )
        ) {

          buyButtons.parentNode.insertBefore(
            wrapper,
            buyButtons
          );

        }


        return true;
      }


      if (mode === 'below_buy_buttons') {

        if (
          !isImmediatelyAfter(
            wrapper,
            buyButtons
          )
        ) {

          buyButtons.parentNode.insertBefore(
            wrapper,
            buyButtons.nextSibling
          );

        }


        return true;
      }


      return true;
    };


    const schedule = () => {

      window.clearTimeout(timer);

      timer = window.setTimeout(
        place,
        60
      );

    };


    place();


    observer = new MutationObserver(
      schedule
    );


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );


    window[registryKey][sectionId] = {

      destroy() {

        destroyed = true;

        window.clearTimeout(timer);

        if (observer) {
          observer.disconnect();
        }

      }

    };

  };


  const initAll = (root = document) => {

    root
      .querySelectorAll(
        '[data-prime-social-proof]'
      )
      .forEach(init);

  };


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => initAll(),
      { once: true }
    );

  } else {

    initAll();

  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {

      const content =
        event.target.querySelector(
          '[data-prime-social-proof]'
        );

      if (content) {
        init(content);
      }

    }
  );


  document.addEventListener(
    'shopify:section:reorder',
    (event) => {

      const content =
        event.target.querySelector(
          '[data-prime-social-proof]'
        );

      if (content) {
        init(content);
      }

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    (event) => {

      const content =
        event.target.querySelector(
          '[data-prime-social-proof]'
        );


      if (!content) {
        return;
      }


      const sectionId =
        content.dataset.sectionId;


      const instance =
        window[registryKey][sectionId];


      if (
        instance &&
        typeof instance.destroy === 'function'
      ) {
        instance.destroy();
      }


      delete window[registryKey][sectionId];

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
